import { Alert, AlertTitle, Button, Collapse } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAuthSlice } from "../../../application/selectors/auth";

const ProfileCompletionAlert = () => {
  const navigate = useNavigate();
  const { user } = useSelector(getAuthSlice);

  // نمایش پیام فقط زمانی که کاربر لاگین کرده باشد و پروفایل تکمیل نشده باشد
  const shouldShowAlert =
    user?.accessToken &&
    (user?.isProfileCompleted === false ||
      user?.isProfileCompleted === undefined);

  if (!shouldShowAlert) {
    return null;
  }

  const handleCompleteProfile = () => {
    navigate("/account/profile");
  };

  return (
    <Collapse in={shouldShowAlert}>
      <Alert
        severity="warning"
        sx={{
          mx: 2,
          mb: 2,
          borderRadius: 2,
          boxShadow: 1,
          position: "relative",
          zIndex: 1,
        }}
        action={
          <Button
            color="warning"
            size="small"
            variant="contained"
            onClick={handleCompleteProfile}
            sx={{ fontWeight: "bold" }}
          >
            تکمیل اطلاعات
          </Button>
        }
      >
        <AlertTitle sx={{ fontWeight: "bold" }}>اطلاعات کاربری ناقص</AlertTitle>
        لطفاً اطلاعات کاربری خود را تکمیل کنید تا بتوانید از تمام امکانات سیستم
        استفاده نمایید.
      </Alert>
    </Collapse>
  );
};

export default ProfileCompletionAlert;
